/* eslint-disable react/no-unstable-nested-components */
import { twClassMerge } from '@healthhub/react-ui';
import { Collapse } from 'antd';
import type { ReactNode } from 'react';

import { OutlinedDownArrowIcon } from '@shared/assets-icon';

import ArticleSection from './ArticleSection';

interface ArticleSectionCollapseProps {
  articleSection: { articles: { title: string; url: string }[]; icon: ReactNode; title: string }[];
  className?: string;
  isEmpty?: boolean;
}

const ArticleSectionCollapse = ({ articleSection, className, isEmpty }: ArticleSectionCollapseProps) => {
  if (isEmpty || articleSection.length === 0) {
    return null;
  }

  return (
    <Collapse
      accordion
      className={twClassMerge('w-full border-none', className)}
      expandIcon={({ isActive }) => (
        <OutlinedDownArrowIcon
          className={twClassMerge(
            '[&>path]:stroke-primary-green-4 [&>path]:stroke-2 transform duration-300 h-5 w-5 static',
            isActive && 'rotate-180'
          )}
        />
      )}
      expandIconPosition="end"
      items={articleSection.map(({ articles, icon, title }) => ({
        key: title,
        label: (
          <div className="flex items-center gap-1">
            {icon}
            <span className="text-sm font-semibold text-primary-blue-grey">{title}</span>
          </div>
        ),
        children: (
          <div className="flex flex-col bg-white px-4 py-6">
            <ArticleSection articles={articles} icon={icon} />
          </div>
        ),
        className:
          'border-b border-functional-haze bg-functional-beige [&_.ant-collapse-content-box]:p-0 [&_.ant-collapse-content]:border-none [&_.ant-collapse-header]:flex  [&_.ant-collapse-header]:items-center [&_.ant-collapse-header]:p-4',
      }))}
    />
  );
};

export default ArticleSectionCollapse;
